import globals from './Globals';
import loader from './Loader';
import RenderContainer from './RenderContainer';

class TextPositionIndicator extends RenderContainer {
  constructor(page) {
    super();
    this.name = 'TextPositionIndicator';
    this.dotImageName = 'dot';
    this.darkDotImageName = 'dot_dark';
    this.dots = [];
    this.numDots = 0;
    this.pageIndex = page

    loader.addItems(this, [this.dotImageName, this.darkDotImageName]);
    this.x = 0;
    this.y = 0;
    this.maxWidth = 0.5;
    this.maxHeight = 0.015;
    const size = globals.relSizeToScreen({
      x: this.maxWidth,
      y: this.maxHeight
    });
    this.width = size.x;
    this.height = size.y;
    this.render.stream = false;
    this.visible = true;
  }

  moveDarkDotTo(dotNumber) {
    const dest = this.dots.find(dot => dot.index === dotNumber).x;
    this.darkDot.x = dest
    this.render.once = true
  }

  static makeDot(dotTag, position, index) {
    const tempBitmap = new createjs.Bitmap(dotTag);
    tempBitmap.x = position;
    tempBitmap.index = index;
    return tempBitmap;
  }

  addPositionDots() {
    const dotTag = loader.getItem(this.dotImageName);

    const dotSize = globals.relSizeToScreen({
      x: 0.08,
      y: 0.08
    });

    this.width = this.numDots * dotSize.x * 2;
    const dotSpacing = dotSize.x * 2.0;
    this.dotContainer = new createjs.Container();

    for (let i = 0; i < this.numDots; i += 1) {
      const position = dotSpacing * i - this.width / 2.0;
      const dot = TextPositionIndicator.makeDot(dotTag, position, i);
      this.dots.push(dot);
    }
    this.dotContainer.addChild(...this.dots);
    this.addChild(this.dotContainer);
    this.shadow = new createjs.Shadow('#000000', 2, 2, 2);
  }

  populateDots(numDots) {
    this.numDots = numDots;
    this.addPositionDots();
    this.addDarkDot();
    this.scaleSize();
  }

  addDarkDot() {
    const darkDotTag = loader.getItem(this.darkDotImageName);
    this.darkDot = new createjs.Bitmap(darkDotTag);
    const position = this.dots[0].x;
    this.darkDot = TextPositionIndicator.makeDot(darkDotTag, position, 0);
    this.addChild(this.darkDot);
  }

  scaleSize() {
    const scaleX = this.width / this.dotContainer.getBounds().width;
    const scaleY = this.height / this.dotContainer.getBounds().height;
    if (scaleX > scaleY) {
      this.scaleX = scaleY;
      this.scaleY = scaleY;
    } else {
      this.scaleX = scaleX;
      this.scaleY = scaleX;
    }
  }

  loaded() {
    this.render.once = true;
    this.render.stream = false;
  }
}

export { TextPositionIndicator as default };
